/**
 * A panel that slides in from the side: a native dialog wrapped in
 * <side-drawer>. A click beside the panel closes it, and its open and close
 * buttons also work in browsers without invoker commands. With
 * `data-close-from="990"` it closes by itself once the window is that wide.
 */
class SideDrawer extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;
    const dialog = this.querySelector('dialog');

    dialog.addEventListener('click', (event) => event.target === dialog && dialog.close(), { signal });

    if (this.dataset.closeFrom) {
      const wide = window.matchMedia(`(width >= ${this.dataset.closeFrom}px)`);
      wide.addEventListener('change', () => wide.matches && dialog.close(), { signal });
    }

    if ('commandForElement' in HTMLButtonElement.prototype) return;

    for (const button of document.querySelectorAll(`[commandfor="${dialog.id}"]`)) {
      const open = button.getAttribute('command') === 'show-modal';
      button.addEventListener('click', () => (open ? dialog.showModal() : dialog.close()), { signal });
    }
  }

  disconnectedCallback() {
    this.#controller.abort();
  }
}

if (!customElements.get('side-drawer')) customElements.define('side-drawer', SideDrawer);
